import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-information-popover',
  templateUrl: './information-popover.component.html',
  styleUrls: ['./information-popover.component.scss'],
})
export class InformationPopoverComponent implements OnInit {

  public titleContent: string;
  public infoContent: string;
  public infoType: string;
  public infoBackground: string;
  constructor(
    private popoverController: PopoverController
  ) { }

  ngOnInit() {
    // console.log("here")
  }

  async closePopover() {
    await this.popoverController.dismiss();
  }

}
